import { Checkbox, Divider, Grid, List, ListItem, ListItemText } from "@mui/material";
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { CancelIcon } from "../../../icon";
import * as selector from '../../../selectors/selectors';
import ButtonComponent from '../button/button.component';
import { buttonLabels } from '../constants';
import { CustomFilterCategory } from "./filter.model";


interface IProps {
    Filters: CustomFilterCategory[];
    HandleApplyFilters: (Filters: CustomFilterCategory[]) => void;
    OnClose?: () => void;
    isReport?: boolean;
}

const FilterComponent = (props: IProps) => {
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
    const IsDarkMode: boolean = useSelector(selector.isDarkMode)
    const [selectedFilters, setSelectedFilters] = useState<CustomFilterCategory[]>(props.Filters);
    const [isAnyFilterSelected, setIsAnyFilterSelected] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState<number | null>(null);

    useEffect(() => {
        const anyFilterSelected = selectedFilters.some(filter => filter.Options.some(option => option.IsSelected));
        setIsAnyFilterSelected(anyFilterSelected);

        if (selectedFilters.length > 0 && selectedCategory === null) {
            setSelectedCategory(selectedFilters[0].Id);
        }

    }, [selectedFilters, selectedCategory]);

    const handleSelectAll = (categoryId: number, checked: boolean) => {
        const updatedFilters = selectedFilters.map((filter) => {
            if (filter.Id === categoryId) {
                return {
                    ...filter,
                    IsSelectedAll: checked,
                    Options: filter.Options.map((option) => ({
                        ...option,
                        IsSelected: checked
                    }))
                };
            }
            return filter;
        });
        setSelectedFilters(updatedFilters);
    };

    const handleOptionChange = (categoryId: number, optionId: string, checked: boolean) => {
        const updatedFilters = selectedFilters.map((filter) => {
            if (filter.Id === categoryId) {
                const updatedOptions = filter.Options.map((option) => {
                    if (option.Id === optionId) {
                        return {
                            ...option,
                            IsSelected: checked
                        };
                    }
                    return option;
                });

                const isAllOptionsSelected = updatedOptions.every((option) => option.IsSelected);

                return {
                    ...filter,
                    IsSelectedAll: isAllOptionsSelected,
                    Options: updatedOptions
                };
            }
            return filter;
        });

        setSelectedFilters(updatedFilters);
    };

    const clearAllFilters = () => {
        const updatedFilters = selectedFilters.map((filter) => ({
            ...filter,
            IsSelectedAll: false,
            Options: filter.Options.map((option) => ({
                ...option,
                IsSelected: false
            }))
        }));
        setSelectedFilters(updatedFilters);
    };

    const handleApply = () => {
        props.HandleApplyFilters(selectedFilters);
        clearAllFilters();
        props.OnClose();
    };

    const handleSelectCategory = (categoryId: number) => {
        setSelectedCategory(categoryId);
    };


    return (
        <>
            {!props.isReport && IsMobileDevice ? (
                <>
                    <div className={`o-x-hidden w-fill`}>
                        <Grid item xs={12}>
                            <div className={`${IsDarkMode ? "" : "paper-background"} d-flex p-2`}>
                                <span className={"h1 color-primary-accent"}>Filters</span>
                                <CancelIcon className={"c-pointer ml-auto"} onClick={props.OnClose} />
                            </div>
                        </Grid>
                        <Grid container direction="row">
                            <Grid item xs={5} className=" bg-color-filter-mobile">
                                <div className="h-v-70 scroll">
                                    <List>
                                        {selectedFilters.map((filter: CustomFilterCategory) => (
                                            <ListItem
                                                key={filter.Id}
                                                button
                                                selected={selectedCategory === filter.Id}
                                                onClick={() => handleSelectCategory(filter.Id)}
                                            >
                                                <ListItemText primary={filter.Title} classes={{ primary: 'h4' }} className="w-space p-1" />
                                                {!!filter.Options.filter(x => x.IsSelected).length && (
                                                    <div className={`h4 bg-color-filter-bubble w-3 h-3 br-4 t-align-center b-none color-secondary d-flex justify-center`}>
                                                        <span className="m-auto">{filter.Options.filter(x => x.IsSelected).length}</span>
                                                    </div>
                                                )}
                                            </ListItem>
                                        ))}
                                    </List>
                                </div>
                                <ButtonComponent
                                    OnClick={clearAllFilters}
                                    ButtonLabel={buttonLabels.RESET}
                                    ClassName={`mx-auto b-none mt-6 w-p-76`}
                                    Variant={"secondary-btn"}
                                />
                            </Grid>
                            <Grid item xs={7} className={`${IsDarkMode ? "" : "paper-background"} box-shadow-display-background-shadow h-v-100 scroll `}>
                                <div className="h-v-70 o-hidden">
                                    {selectedCategory !== null && (
                                        <>
                                            <div className={"h4 d-flex font-bold w-p-100 ml-2 h-p-9 pt-2"}>
                                                <Checkbox
                                                    name="checkbox"
                                                    onChange={(event) => handleSelectAll(selectedCategory, event.target.checked)}
                                                    classes={{ checked: "selected-checkbox" }}
                                                    checked={selectedFilters.find(filter => filter.Id === selectedCategory)?.IsSelectedAll}
                                                />
                                                <span className={`my-auto h1 color-primary-accent`}>Select All</span>
                                            </div>
                                            <div className="scroll h-p-75">
                                                {selectedFilters
                                                    .find(filter => filter.Id === selectedCategory)
                                                    ?.Options.map((option, index) => (
                                                        <div key={index} className={"h4 d-flex font-bold w-p-100 ml-2 h-p-12"}>
                                                            <Checkbox
                                                                name="checkbox"
                                                                onChange={(event) =>
                                                                    handleOptionChange(selectedCategory, option.Id, event.target.checked)
                                                                }
                                                                classes={{ checked: "selected-checkbox" }}
                                                                checked={option.IsSelected}
                                                            />
                                                            <span className={`my-auto`}>{option.Label}</span>
                                                        </div>
                                                    ))}
                                            </div>
                                        </>
                                    )}
                                </div>

                                <ButtonComponent
                                    OnClick={handleApply}
                                    ButtonLabel={buttonLabels.APPLY}
                                    ClassName={'mx-auto w-p-76 mt-6 justify-center'}
                                    Variant={"primary-btn"}
                                />
                            </Grid>
                        </Grid>
                    </div>
                </>
            ) : (
                <>
                    <div className={`d-flex flex-direction ${IsDarkMode ? "bg-color-sidebar-bg" : "bg-color-primary-background"}`}>
                        <div className="d-flex justify-between pt-2 px-2 pb-1">
                            <div className="h4-semibold my-auto">Filters</div>
                            <div className={`h6-regular my-auto c-poter ${isAnyFilterSelected && 'color-vigenary-light c-pointer'}`} onClick={clearAllFilters}>
                                Clear All
                            </div>
                        </div>
                        <div className='px-3'><Divider light /></div>
                        {selectedFilters.length > 0 && selectedFilters.some(filter => filter.Options.length > 0) ?
                            <div className="d-flex justify-between py-2 align-left pr-2">
                                {selectedFilters.map((filter) => (
                                    <div key={filter.Id}>
                                        <span className='h5-semibold my-auto pl-2'>{filter.Title}</span>
                                        <ListItem className='pb-0 pl-2 pt-2'>
                                            <Checkbox
                                                checked={filter.IsSelectedAll}
                                                onChange={(event) => handleSelectAll(filter.Id, event.target.checked)}
                                                classes={{ root: "p-0", checked: "selected-checkbox" }}
                                            />
                                            <ListItemText classes={{ primary: 'h5-regular' }} primary={"Select All"} />
                                        </ListItem>
                                        <List classes={{ padding: "py-0" }}>
                                            {filter.Options.map((option) => (
                                                <ListItem key={option.Id} className='pt-1 pb-0 pl-2'>
                                                    <Checkbox
                                                        checked={option.IsSelected}
                                                        onChange={(event) => handleOptionChange(filter.Id, option.Id, event.target.checked)}
                                                        classes={{ root: "p-0", checked: "selected-checkbox" }}
                                                    />
                                                    <ListItemText classes={{ primary: 'h5-regular' }} primary={option.Label} />
                                                </ListItem>
                                            ))}
                                        </List>
                                    </div>
                                ))}
                            </div>
                            :
                            <div className='d-flex flex-direction justify-center align-center h-v-20'>
                                <span className='h5-regular'>There are no filters</span>
                            </div>
                        }
                        {
                            props.Filters.every(x => x.Options.length === 0) ? null : <div className=' d-flex px-2 mt-auto mb-2 pt-1'>
                                <ButtonComponent ButtonLabel='Cancel' Variant='secondary-btn-small' OnClick={() => { props.OnClose() }} ClassName={" ml-auto"} />
                                <ButtonComponent ButtonLabel='Apply' Variant='primary-btn-small' OnClick={handleApply} ClassName={"px-4 ml-1"} />
                            </div>
                        }
                    </div>
                </>
            )}
        </>
    );
}

export default FilterComponent;
